import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import {Modal} from "react-bootstrap";
import MonthlyTable from "../../../monthly/components/MonthlyTable";
import {bindActionCreators} from "redux";
import * as monthlyActions from "../../../monthly/actions/monthlyActions";
import * as tasksActions from "../actions/tasksActions";

class TaskMonthlyModal extends React.Component {

    constructor(props) {
        super(props);
        this.onChangeWorkCheckType = this.onChangeWorkCheckType.bind(this);
        this.onChangeWorkCheckTypeAll = this.onChangeWorkCheckTypeAll.bind(this);
        this.onSortByColumn = this.onSortByColumn.bind(this);
    }

    componentWillMount() {
        this.props.monthlyActions.getWorkCheckStates();
    }

    onChangeWorkCheckType(workerId, workCheckTypeId, workCheckStateId) {
        const {task} = this.props;
        this.props.monthlyActions.saveWorkCheckType(task.construction.id, task.year, task.month,
            task.company_child.id, workerId, workCheckTypeId, workCheckStateId)
    }

    onChangeWorkCheckTypeAll(workCheckTypeId, workCheckStateId) {
        const {task} = this.props;
        const workerIds = Object.keys(this.props.workers).map((workerId) => workerId);
        this.props.monthlyActions.saveWorkCheckTypeBatch(task.construction.id, task.year, task.month,
            task.company_child.id, workerIds, workCheckTypeId, workCheckStateId);
    }

    onSortByColumn(columnSortedSelected) {
        this.props.monthlyActions.sortWorkChecks(columnSortedSelected);
    }

    render() {
        const {
            task,
            tasksActions,
            show,
            onHide,
            title,
            date,
            build,
            subtitle,
            days,
            workersSorted,
            dayChecksByWorker,
            monthChecksByWorker,
            workCheckTypes,
            workCheckStates,
            columnSortedSelected,
            columnSortAsc,
        } = this.props;

        return (
            <div onFocus={() => {
                if (task) {
                    tasksActions.updateWorkChecks(task);
                }
            }}>
                <Modal
                    show={show}
                    onHide={onHide}
                    bsSize="large"
                    aria-labelledby="contained-modal-title-lg"
                    className={'modal-full'}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-lg">
                            {title}<br/>
                            <small>{date}</small><br/>
                            <small>{build}</small><br/>
                            <small>{subtitle}</small>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <MonthlyTable
                            days={days}
                            workers={workersSorted}
                            dayChecksByWorker={dayChecksByWorker}
                            monthChecksByWorker={monthChecksByWorker}
                            workCheckTypes={workCheckTypes}
                            workCheckStates={workCheckStates}
                            onChangeWorkCheckType={this.onChangeWorkCheckType}
                            onChangeWorkCheckTypeAll={this.onChangeWorkCheckTypeAll}
                            tableClass={'table-trabajadores'}
                            showDocumentsOfWorker={true}
                            columnSortedSelected={columnSortedSelected}
                            columnSortAsc={columnSortAsc}
                            onSortByColumn={this.onSortByColumn}
                            fixedThs={false}
                        />
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return ({
        task: state.tasks.taskMonthly,
        workCheckStates: state.monthly.workCheckStates,
        workCheckTypes: state.monthly.workCheckTypes,
        days: state.monthly.days,
        workers: state.monthly.workers,
        workersSorted: state.monthly.workersSorted,
        dayChecksByWorker: state.monthly.dayChecksByWorker,
        monthChecksByWorker: state.monthly.monthChecksByWorker,
        columnSortedSelected: state.monthly.columnSortedSelected,
        columnSortAsc: state.monthly.columnSortAsc,
    });
};

const mapDispatchToProps = dispatch => ({
    monthlyActions: bindActionCreators(monthlyActions, dispatch),
    tasksActions: bindActionCreators(tasksActions, dispatch),
});


export default connect(mapStateToProps, mapDispatchToProps)(TaskMonthlyModal);


TaskMonthlyModal.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    build: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func,
};

TaskMonthlyModal.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/list/components/TaskMonthlyModal.js